/* No em dashes on the site (Joe's rule). Supplier copy, Judge.me reviews and older data still carry them, so the text on
   the page is tidied as it appears: a dash between two parts of a sentence becomes a comma, one before a number
   (a size or a quantity) becomes a hyphen. Only the shown text changes; nothing in the store is edited. */
(function () {
  var D = '—';
  function fix(s) { return s.replace(/\s*—\s*(\d)?/g, function (m, d) { return d ? ' - ' + d : ', '; }); }
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, CODE: 1, PRE: 1 };
  function walk(root) {
    if (!root || !document.createTreeWalker) return;
    if (root.nodeType === 3) { if (root.nodeValue.indexOf(D) > -1 && !(root.parentNode && SKIP[root.parentNode.nodeName])) root.nodeValue = fix(root.nodeValue); return; }
    if (root.nodeType !== 1 || SKIP[root.nodeName]) return;
    var w = document.createTreeWalker(root, 4, null), n, hit = [];
    while ((n = w.nextNode())) if (n.nodeValue.indexOf(D) > -1 && !SKIP[n.parentNode.nodeName]) hit.push(n);
    hit.forEach(function (t) { t.nodeValue = fix(t.nodeValue); });
  }
  function title() { if (document.title.indexOf(D) > -1) document.title = fix(document.title); }
  var queue = [], pending = false;
  function flush() { pending = false; var q = queue; queue = []; q.forEach(walk); }
  function start() {
    walk(document.body); title();
    if (!window.MutationObserver) return;
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (m.type === 'characterData') queue.push(m.target);
        else Array.prototype.forEach.call(m.addedNodes, function (x) { queue.push(x); });
      });
      if (!pending && queue.length) { pending = true; (window.requestAnimationFrame || setTimeout)(flush); }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
